export default "__VITE_ASSET__BOuV4uJn__"